export default "__VITE_ASSET__C0eXOIt8__"